import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-480caca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = { class: "card_text_and_image_wrapper" }
const _hoisted_3 = { class: "card_text_and_image_wrapper" }
const _hoisted_4 = { class: "card_text_and_image_wrapper" }
const _hoisted_5 = { class: "card_text_and_image_wrapper" }
const _hoisted_6 = { class: "card_text_and_image_wrapper" }
const _hoisted_7 = { class: "card_text_and_image_wrapper" }

import TextBlock from "../blocks/TextBlock.vue";
import ContentWrapper from "../generics/ContentWrapper.vue";
import PageTitle from "../blocks/PageTitle.vue";
import CustomCard from "../generics/CustomCard.vue";
import CustomPic from "../generics/CustomPic.vue";
import TextImgContentBlock from "../blocks/TextImgContentBlock.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'GuideView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(ContentWrapper, { backgroundImageClass: "background-trainbridge" }, {
    default: _withCtx(() => [
      _createVNode(PageTitle, { text: "Guider" }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/tagluffning-for-nyborjare"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/map_detail_view.jpg",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Tågluffning för nybörjare",
                  content: "Innan man ger sig ut i Europa är det bra att känna till tips, tricks och i allmänhet veta hur man bör gå tillväga för att tågluffa. I denna guide finns information värd att veta och tips för en lyckad resa."
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/destinationer"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/interrail-countries-tagluffaieuropa.png",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Destinationer",
                  content: "I denna guide listar vi destinationer i form av länder med tillhörande landsspecifika guider för din tågluff i Europa. Du kan finna reda på de vackraste stränderna i italien, de vackraste vandringslederna i Schweiz, de mest spektakulära pubarna i Tjeckien och vackra vingårdar i Frankrike. Läs mer."
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/mobile-pass"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/passguide/aktivera-mobile-pass.png",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Så aktiverar du ditt Mobila Pass",
                  content: "Vi hjälper dig genom alla steg till att lyckas aktivera ditt mobila interrail pass."
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/top-10-beaches"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/sveti-stefan.jpg",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Top 10 stränder",
                  content: "Gå igenom vår lista av de allra bästa stränderna i Europa som du dessutom kan nå enkelt med tåget. Oavsett om det är klippor, sand, kallt eller varmt; dessa får du inte missa!"
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/packning"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/backpack.jpg",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Hur ska man packa?",
                  content: "Något utav de besvärligare momenteten inför en resa är packningen där man behöver bestämma sig för vad som ska med och vad som skall lämnas hemma. Man vill å ena sidan inte packa för mycket, men å andra sidan inte heller skära ner på nödvändigheter. I denna guide hjälper vi dig med din packning."
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/valj-interrailkort"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/ticket_closeup.jpg",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Vilket interrailkort ska jag välja?",
                  content: "Det finns 10 olika typer av interrailkort att välja mellan, så det är inte helt lätt att veta vilken man ska ta. Vi hjälper dig ta reda på vilken som passar din resa!"
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        class: "destyle-link",
        to: "guider/med-pa-resan"
      }, {
        default: _withCtx(() => [
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/bringOnTrip.png",
                  height: "20rem"
                }),
                _createVNode(TextBlock, {
                  header: "Vad får jag med på resan?",
                  content: "Vi går igenom vad man får med sig på sin resa genom Europa och vilka förberedelser man kan behöva göra för att det ska gå så smidigt som möjligt."
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})